/* eslint-disable */
import networkEnv from '@/app-config/networks/index'
const network = networkEnv

export default require(`./${network.VUE_APP_NETWORK_ENV}`).default.flat()
